<div class="bg-col-w p-a-2 p-a-0-s">
    @if (title) {
    <div
         class="p-b-2 p-b-4-s p-b-4-m m-t-12-x m-t-12-l flex-x flex-l flex-middle center-s center-m pos-relative-s pos-relative-m m-r--4-s m-l--4-s">
        @if (url) {
        <a class="pos-absolute-s pos-absolute-m left-0 top-3 top-0-s top-0-m"
           [routerLink]="url">
            <i class="icon-arrow-left m-l-4"></i>
        </a>
        }

        @if (onBackClick && !url) {
        <button class="pos-absolute-s pos-absolute-m left-0 top-3 top-0-s top-0-m"
                type="button"
                (click)="onBackClick()">
            <i class="icon-arrow-left m-l-4"></i>
        </button>
        }
        <h1 class="m-l-4"
            [sizeClass]="'XL:q1, SM:fw-bold'">
            {{title | translate}}
        </h1>
    </div>

    <div class="w-12">
        <ng-content />
    </div>
    }
</div>
